<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Основные">
				<payment-update :paymentId="id" v-if="activeTab === tabs.main"></payment-update>
			</b-tab>
			<b-tab title="Участники">
				<payment-update-participant :id="id" v-if="activeTab === tabs.members"></payment-update-participant>
			</b-tab>
			<b-tab title="Бронирование мест">
				<payment-update-reservation :id="id" v-if="activeTab === tabs.reservation"></payment-update-reservation>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import paymentModel from '@/models/payment/payment'
import PaymentUpdate from '@/components/payment/update/default.vue'
import PaymentUpdateParticipant from '@/components/payment/update/participant'
import PaymentUpdateReservation from '@/components/payment/update/reservation'

const tabs = {
	main: 0,
	members: 1,
	reservation: 2
}

export default {
	components: {
		'payment-update': PaymentUpdate,
		'payment-update-participant': PaymentUpdateParticipant,
		'payment-update-reservation': PaymentUpdateReservation
	},
	data () {
		return {
			id: 0,
			activeTab: tabs.main,
			tabs: tabs,
			type: ''
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		paymentModel.getProductTypeByPaymentId(this.id).then((productType) => {
			this.type = productType
		})
	},
	methods: {
		handleTab (tab, event) {
		}
	},
	beforeRouteUpdate (to, from, next) {
		this.id = parseInt(to.params.id)
		next()
	}
}
</script>
<style>
	.el-alert {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/payment/detail/update.vue